/**
 * mango-filter.js — v7
 * Buton #ProductGridContainer'ın DIŞINA (hemen önüne sibling olarak) eklenir.
 * AJAX container içini günceller, dışındaki butona dokunmaz → kaybolmaz.
 */
(function () {
  'use strict';

  var COLOR_LIMIT = 12;

  var CM = {
    SIYAH:'#1A1A1A',BLACK:'#1A1A1A',
    BEYAZ:'#F5F5F0',WHITE:'#F5F5F0','OPTIK BEYAZ':'#F5F5F0',
    GRI:'#9EA7AA',GRAY:'#9EA7AA',GREY:'#9EA7AA',
    'ACIK-GRI':'#CDD0D4','GRI MELANJ':'#CDD0D4',MELANJ:'#CDD0D4',
    'KOYU-GRI':'#393E46',ANTRASIT:'#393E46',
    GUMUS:'#BFC9CA',SILVER:'#BFC9CA',
    KIRMIZI:'#C0392B',RED:'#C0392B',
    BORDO:'#6D1A22',BURGUNDY:'#6D1A22',MAROON:'#6D1A22',
    VISNE:'#8B1A2B',CHERRY:'#8B1A2B','NAR CICEGI':'#E8354A',
    KESTANE:'#954535',CHESTNUT:'#954535',
    PEMBE:'#F48FB1',PINK:'#F48FB1','ACIK-PEMBE':'#F9C4D4',
    'NEON-PEMBE':'#FF1493','SEKER PEMBE':'#FFAEC9',PUDRA:'#E8C4C4',
    'GUL KURUSU':'#C17C8A',ROSE:'#D4A0A8',
    FUSYA:'#D81B60',FUCHSIA:'#D81B60','ACIK-FUSYA':'#F06292','NEON-FUSYA':'#FF00AA',
    TURUNCU:'#E67E22',ORANGE:'#E67E22',
    ORANJ:'#FF6A1A',ORANCE:'#FF6A1A','ACIK-ORANJ':'#FFAA66','NEON-ORANJ':'#FF4500',
    CORAL:'#F4745C',SOMON:'#FA8072',SALMON:'#FA8072',
    KIREMIT:'#C0533A','ACIK-KIREMIT':'#D4735A',TARCIN:'#8B4513',
    'BAL KABAGI':'#F5A623','KAVUN ICI':'#F5A623',KAVUNICI:'#F5A623',MANGO:'#FF8C00',
    SARI:'#F1C40F',YELLOW:'#F1C40F','ACIK-SARI':'#F5E176','NEON-SARI':'#FFFF00',
    'LIMON SARISI':'#CFED52',LIME:'#CFED52',HARDAL:'#C9A63A',MUSTARD:'#C9A63A',
    ALTIN:'#CFB53B',GOLD:'#CFB53B','ASIT SARI':'#E8FF00',SAFRAN:'#F4A900',
    YESIL:'#27AE60',GREEN:'#27AE60','ACIK-YESIL':'#88CC88','NEON-YESIL':'#39FF14',
    'KOYU-YESIL':'#1E5631','ELMA YESILI':'#8DB600',
    MINT:'#A8D8B9','MINT YESILI':'#A8D8B9','MINT-YESILI':'#A8D8B9',
    'FISTIK YESILI':'#93C572',ADACAYI:'#7B9E87','ASKER YESILI':'#4B5320',
    ZUMRUT:'#009473',EMERALD:'#009473',OLIVE:'#6B7C2B',
    CAGLA:'#8FAF65','CAGLA YESILI':'#8FAF65','YAG YESILI':'#6E8B3D',FINDIK:'#8B7355',
    MAVI:'#2E86C1',BLUE:'#2E86C1','ACIK-MAVI':'#7EB8D4',
    'BEBE-MAVI':'#AED6F1','BEBE MAVI':'#AED6F1','BUZ MAVI':'#CAE4F5',
    LACIVERT:'#1B2A6B',NAVY:'#1B2A6B',SAKS:'#3D7AB5',SAX:'#3D7AB5',INDIGO:'#3F51B5',
    DENIM:'#3B6FA0',JEAN:'#3B6FA0','CAM GOBEGI':'#5BA4CF',
    AQUA:'#00B5CC',TURKUAZ:'#1ABC9C',TURQUOISE:'#1ABC9C',PETROL:'#005F73',
    MOR:'#8E44AD',PURPLE:'#8E44AD',VIOLET:'#8E44AD','ACIK-MOR':'#B39DDB',
    LILA:'#9B84B4',LILAC:'#9B84B4',LEYLAK:'#967BB6',LAVENDER:'#967BB6',
    'MOR TURKUAZ':'#6A5ACD',MURDUM:'#6C3461',
    BEJ:'#D4B896',BEIGE:'#D4B896','BEJ TON':'#C9AA87',
    EKRU:'#EDE0CC',ECRU:'#EDE0CC',HAM:'#E8DCC8',NATUREL:'#E8DCC8',
    KREM:'#FFFACD',CREAM:'#FFFACD',KEMIK:'#F5EDD6',BONE:'#F5EDD6',
    BISKUVI:'#F5EDD6',IVORY:'#F5EDD6',VANILYA:'#F3E5AB',VANILLA:'#F3E5AB',
    TABA:'#B8956A',TAS:'#A09080',STONE:'#A09080',TAUPE:'#A09080',
    KUM:'#D4C5A9',SAND:'#D4C5A9',LAMELA:'#C8B8A2',
    CAMEL:'#C19A6B','ACIK-CAMEL':'#D9B896','KOYU-CAMEL':'#9A7040',
    DORE:'#C8A86A',HAKI:'#8B864E',KHAKI:'#8B864E','ACIK-HAKI':'#A8A87A',
    KAHVE:'#7B4B2A',BROWN:'#7B4B2A','ACIK-KAHVE':'#C49A6C','KOYU-KAHVE':'#3D1F0D',
    KARAMEL:'#C68642',CARAMEL:'#C68642',CAPPUCINO:'#9E7B5A',CAPPUCCINO:'#9E7B5A',
    CIKOLATA:'#4E2210',CHOCOLATE:'#4E2210',VIZON:'#B09080',MINK:'#B09080',
    BAKIR:'#B87333',COPPER:'#B87333',BRONZE:'#8C6239',BRONZ:'#8C6239',
    'COK RENKLI':'MULTI','COKRENKLI':'MULTI','CIG RENKLI':'MULTI','CIG RENK':'MULTI',
    MULTICOLOR:'MULTI','MULTI RENK':'MULTI',BENETTON:'MULTI',
  };
  var MULTI_BG  = 'linear-gradient(135deg,#E74C3C 0%,#F39C12 25%,#2ECC71 50%,#3498DB 75%,#9B59B6 100%)';
  var LIGHT_HEX = ['#F5F5F0','#FFFACD','#F5EDD6','#EDE0CC','#E8DCC8','#F3E5AB','#CAE4F5','#F9C4D4','#FFAEC9','#F5E176','#CDD0D4','#BFC9CA'];

  function norm(s) {
    return String(s).toUpperCase()
      .replace(/İ/g,'I').replace(/Ğ/g,'G').replace(/Ş/g,'S')
      .replace(/Ö/g,'O').replace(/Ü/g,'U').replace(/Ç/g,'C')
      .replace(/ı/g,'I').replace(/\s+/g,' ').trim();
  }
  function getBg(name) {
    var n=norm(name);
    if (CM[n]==='MULTI') return MULTI_BG;
    if (CM[n]) return CM[n];
    var d=n.replace(/ /g,'-');
    if (CM[d]&&CM[d]!=='MULTI') return CM[d];
    var pts=n.split(/[\s-]+/);
    if (pts.length===2){
      var h1=CM[pts[0]],h2=CM[pts[1]];
      if (h1==='MULTI'||h2==='MULTI') return MULTI_BG;
      if (h1&&h2) return 'linear-gradient(135deg,'+h1+' 0%,'+h1+' 50%,'+h2+' 50%,'+h2+' 100%)';
      if (h1) return h1; if (h2) return h2;
    }
    return '#CCCCCC';
  }
  function isLight(bg) {
    return LIGHT_HEX.some(function(c){ return bg.toUpperCase().startsWith(c.toUpperCase()); });
  }

  var ICON_CLOSE   = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var ICON_CHEVRON = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 7L11 1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_FILTER  = '<svg width="16" height="14" viewBox="0 0 16 14" fill="none"><path d="M1 1H15M4 7H12M6.5 13H9.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

  var NT_LABELS = null;
  function ntLabel(key, fallback) {
    if (!NT_LABELS) {
      var el = document.getElementById('nt-ui-labels');
      try { NT_LABELS = el ? JSON.parse(el.textContent) : {}; } catch (e) { NT_LABELS = {}; }
    }
    return (NT_LABELS && NT_LABELS[key]) ? NT_LABELS[key] : fallback;
  }

  function getSourceForm() {
    return document.querySelector('.facets__form,form[data-filter-form],form[action*="collection"]');
  }

  var drawer, overlay, applyBtn, clearBtn, badgeEl;
  var sourceForm = null;
  var filterData = null;

  function loadData() {
    var el = document.getElementById('mf-filter-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function findCheckbox(paramName, value) {
    sourceForm = getSourceForm();
    if (!sourceForm) return null;
    var all = sourceForm.querySelectorAll('input[type="checkbox"][name="'+paramName+'"]');
    for (var i=0; i<all.length; i++) {
      var v = all[i].value;
      if (v===value || decodeURIComponent(v)===value || v===encodeURIComponent(value)) return all[i];
      if (norm(v)===norm(value)) return all[i];
    }
    return null;
  }

  function readChecked(paramName, value) {
    var cb = findCheckbox(paramName, value);
    return cb ? cb.checked : false;
  }

  function toggleFilter(paramName, value) {
    var cb = findCheckbox(paramName, value);
    if (!cb) return null;
    cb.click();
    return cb.checked;
  }

  function getActiveCount() {
    sourceForm = getSourceForm();
    if (!sourceForm) return 0;
    return sourceForm.querySelectorAll('input[type="checkbox"]:checked').length;
  }

  function updateBadge() {
    badgeEl = document.querySelector('.mf-badge');
    if (!badgeEl) return;
    var c = getActiveCount();
    badgeEl.textContent = c;
    badgeEl.style.display = c > 0 ? 'inline-flex' : 'none';
  }

  function updateClearBtn() {
    if (clearBtn) clearBtn.disabled = getActiveCount() === 0;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fullSync();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function fullSync() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-param][data-val]').forEach(function(el) {
      el.classList.toggle('is-active', readChecked(el.dataset.param, el.dataset.val));
    });
    var cur = (document.querySelector('select[name="sort_by"]') || {}).value || '';
    drawer.querySelectorAll('.mf-sort-item').forEach(function(item) {
      item.classList.toggle('is-active', item.dataset.value === cur);
    });
    updateBadge();
    updateClearBtn();
  }

  var COLOR_LABELS = ['renk','renkler','color','colour'];

  function getFilterType(label, type) {
    if (type==='price_range') return 'price';
    var n=norm(label);
    if (COLOR_LABELS.some(function(l){ return n===norm(l); })) return 'color';
    return 'list';
  }

  function buildColorGroup(filter) {
    var values=filter.values||[];
    if (!values.length) return null;
    var visible='',hidden='',hiddenCount=0;
    values.forEach(function(v,idx) {
      var bg=getBg(v.label);
      var light=isLight(bg)?' data-light="1"':'';
      var active=v.active?' is-active':'';
      var esc=v.value.replace(/"/g,'&quot;');
      var pn=v.param_name.replace(/"/g,'&quot;');
      var cell='<div class="mf-color-item'+active+'" data-param="'+pn+'" data-val="'+esc+'"'+light+'>'+
               '<span class="mf-color-dot" style="background:'+bg+';"></span>'+
               '<span class="mf-color-name">'+v.label+'</span>'+
               '</div>';
      if (idx<COLOR_LIMIT){visible+=cell;}else{hidden+=cell;hiddenCount++;}
    });
    var html='<div class="mf-color-grid">'+visible+'</div>';
    if (hiddenCount>0){
      html+='<div class="mf-color-grid mf-color-grid--hidden" style="display:none;">'+hidden+'</div>'+
            '<button type="button" class="mf-show-more-btn">'+
            '<span class="mf-show-more-text">'+ntLabel('showMore','Daha Fazla Gör')+'</span>'+
            '<span class="mf-show-more-count">+'+hiddenCount+'</span>'+
            '</button>';
    }
    return html;
  }

  function buildListGroup(filter) {
    var values=filter.values||[];
    if (!values.length) return null;
    var html='<div class="mf-list-grid">';
    values.forEach(function(v) {
      var active=v.active?' is-active':'';
      var esc=v.value.replace(/"/g,'&quot;');
      var pn=v.param_name.replace(/"/g,'&quot;');
      html+='<div class="mf-list-item'+active+'" data-param="'+pn+'" data-val="'+esc+'">'+v.label+'</div>';
    });
    html+='</div>';
    return html;
  }

  function buildPriceGroup(filter) {
    return '<div class="mf-price-range">'+
           '<div class="mf-price-inputs">'+
           '<input class="mf-price-input" type="number" placeholder="'+ntLabel('priceMin','Min')+'" '+
           'value="'+(filter.min_value||'')+'" data-price-param="'+filter.param_name_min+'">'+
           '<span class="mf-price-sep">—</span>'+
           '<input class="mf-price-input" type="number" placeholder="'+ntLabel('priceMax','Max')+'" '+
           'value="'+(filter.max_value||'')+'" data-price-param="'+filter.param_name_max+'">'+
           '</div></div>';
  }

  function buildSortGroup(data) {
    if (!data.sort_options||!data.sort_options.length) return null;
    var cur=data.sort_by||'';
    var html='<div class="mf-sort-list">';
    data.sort_options.forEach(function(opt) {
      var active=opt.value===cur?' is-active':'';
      html+='<div class="mf-sort-item'+active+'" data-value="'+opt.value+'">'+
            '<span class="mf-sort-radio"></span>'+opt.name+'</div>';
    });
    html+='</div>';
    return html;
  }

  function buildGroupsHtml() {
    var groupsHtml='';
    var firstOpen=true;

    if (filterData&&filterData.filters) {
      filterData.filters.forEach(function(filter) {
        var type=getFilterType(filter.label,filter.type);
        var contentHtml=type==='color'?buildColorGroup(filter)
                       :type==='price'?buildPriceGroup(filter)
                       :buildListGroup(filter);
        if (!contentHtml) return;
        var openClass=firstOpen?' is-open':'';
        firstOpen=false;
        groupsHtml+=
          '<div class="mf-group'+openClass+'" data-group-type="'+type+'">'+
            '<button type="button" class="mf-group-header">'+
              '<span class="mf-group-title">'+filter.label+'</span>'+
              '<span class="mf-group-arrow">'+ICON_CHEVRON+'</span>'+
            '</button>'+
            '<div class="mf-group-content">'+contentHtml+'</div>'+
          '</div>';
      });
      var sortHtml=buildSortGroup(filterData);
      if (sortHtml) {
        groupsHtml+=
          '<div class="mf-group" data-group-type="sort">'+
            '<button type="button" class="mf-group-header">'+
              '<span class="mf-group-title">'+ntLabel('sort','Sıralama')+'</span>'+
              '<span class="mf-group-arrow">'+ICON_CHEVRON+'</span>'+
            '</button>'+
            '<div class="mf-group-content">'+sortHtml+'</div>'+
          '</div>';
      }
    }
    return groupsHtml || '<p style="padding:24px;color:#999;font-size:12px;">'+ntLabel('empty','Filtre bulunamadı.')+'</p>';
  }

  function buildDrawer() {
    filterData=loadData();
    sourceForm=getSourceForm();

    var groupsHtml=buildGroupsHtml();
    var title=ntLabel('title','Filtrele ve Sırala');

    drawer=document.createElement('div');
    drawer.className='mf-drawer';
    drawer.id='mf-drawer-singleton';
    drawer.setAttribute('role','dialog');
    drawer.setAttribute('aria-modal','true');
    drawer.setAttribute('aria-label',title);
    drawer.innerHTML=
      '<div class="mf-header">'+
        '<span class="mf-header-title">'+title+'</span>'+
        '<button type="button" class="mf-close-btn" aria-label="'+ntLabel('close','Kapat')+'">'+ICON_CLOSE+'</button>'+
      '</div>'+
      '<div class="mf-body">'+groupsHtml+'</div>'+
      '<div class="mf-footer">'+
        '<button type="button" class="mf-apply-btn">'+ntLabel('apply','Ürünleri Göster')+'</button>'+
        '<button type="button" class="mf-clear-btn" disabled>'+ntLabel('clear','Filtreleri Kaldır')+'</button>'+
      '</div>';

    overlay=document.createElement('div');
    overlay.className='mf-overlay';
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    applyBtn=drawer.querySelector('.mf-apply-btn');
    clearBtn=drawer.querySelector('.mf-clear-btn');
  }

  function bindEvents() {
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelector('.mf-close-btn').addEventListener('click', closeDrawer);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });

    drawer.addEventListener('click',function(e) {
      var gh = e.target.closest('.mf-group-header');
      if (gh) {
        gh.closest('.mf-group').classList.toggle('is-open');
        return;
      }
      var item = e.target.closest('.mf-color-item, .mf-list-item');
      if (item && item.dataset.param) {
        var newState = toggleFilter(item.dataset.param, item.dataset.val);
        if (newState !== null) item.classList.toggle('is-active', newState);
        updateBadge(); updateClearBtn();
        return;
      }
      var si = e.target.closest('.mf-sort-item');
      if (si) {
        drawer.querySelectorAll('.mf-sort-item').forEach(function(i){ i.classList.remove('is-active'); });
        si.classList.add('is-active');
        var sel = document.querySelector('select[name="sort_by"]');
        /* Eski: if (sel){ sel.value=si.dataset.value; sel.dispatchEvent(new Event('change',{bubbles:true})); } */
        if (sel){
          sel.value=si.dataset.value;
          sel.dispatchEvent(new Event('change',{bubbles:true}));
          sel.dispatchEvent(new Event('input',{bubbles:true}));
        }
        return;
      }
      var sm = e.target.closest('.mf-show-more-btn');
      if (sm) {
        var gc = sm.closest('.mf-group-content');
        var hg = gc&&gc.querySelector('.mf-color-grid--hidden');
        if (hg){ hg.style.display='grid'; sm.style.display='none'; }
        return;
      }
    });

    drawer.addEventListener('change', function(e) {
      var inp = e.target.closest('[data-price-param]');
      if (!inp) return;
      sourceForm = getSourceForm();
      if (!sourceForm) return;
      var src=sourceForm.querySelector('input[name="'+inp.dataset.priceParam+'"]');
      if (src){ src.value=inp.value; src.dispatchEvent(new Event('change',{bubbles:true})); }
    });

    /* Eski: applyBtn.addEventListener('click', closeDrawer); */
    applyBtn.addEventListener('click', function() {
      var sel = document.querySelector('select[name="sort_by"]');
      if (sel) {
        sel.dispatchEvent(new Event('change', {bubbles:true}));
        sel.dispatchEvent(new Event('input', {bubbles:true}));
      }
      closeDrawer();
    });

    clearBtn.addEventListener('click',function() {
      sourceForm = getSourceForm();
      if (!sourceForm) return;
      sourceForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb){ cb.click(); });
      sourceForm.querySelectorAll('input[name*="price"]').forEach(function(i){ i.value=''; });
      drawer.querySelectorAll('[data-price-param]').forEach(function(i){ i.value=''; });
      var sel=document.querySelector('select[name="sort_by"]');
      if (sel){ sel.selectedIndex=0; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      drawer.querySelectorAll('.mf-color-grid--hidden').forEach(function(g){ g.style.display='none'; });
      drawer.querySelectorAll('.mf-show-more-btn').forEach(function(b){ b.style.display=''; });
      drawer.querySelectorAll('.is-active').forEach(function(el){ el.classList.remove('is-active'); });
      drawer.querySelectorAll('.mf-sort-item:first-child').forEach(function(el){ el.classList.add('is-active'); });
      updateBadge(); updateClearBtn();
    });

    document.addEventListener('change', function(e) {
      if (!e.target.closest('.facets__form, form[data-filter-form], form[action*="collection"]')) return;
      sourceForm = getSourceForm();
      updateBadge(); updateClearBtn();
      if (drawer && drawer.classList.contains('is-open')) fullSync();
    });
  }

  /* ─────────────────────────────────────────────────────────────
     BUTON YÖNETİMİ
     FİX v7: Buton artık gerçekten #ProductGridContainer'ın DIŞINA,
     hemen önüne (parentNode.insertBefore) ekleniyor.
     AJAX yalnızca container'ın içini günceller → buton kaybolmaz.
     MutationObserver artık container'ın parent'ını izler, sadece
     .mf-trigger-wrap silinirse yeniden ekler.
  ─────────────────────────────────────────────────────────────── */
  var triggerWrap = null;
  var reinjectBusy = false;

  function injectBtn() {
    if (document.querySelector('.mf-trigger-wrap')) return;

    var container = document.querySelector('#ProductGridContainer');
    if (!container || !container.parentNode) return;

    triggerWrap = document.createElement('div');
    triggerWrap.className = 'mf-trigger-wrap';
    triggerWrap.innerHTML =
      '<button type="button" class="mf-trigger-btn">' +
        ICON_FILTER +
        '<span>'+ntLabel('title','Filtrele ve Sırala')+'</span>' +
        '<span class="mf-badge" style="display:none;">0</span>' +
      '</button>';

    badgeEl = triggerWrap.querySelector('.mf-badge');
    triggerWrap.querySelector('.mf-trigger-btn').addEventListener('click', openDrawer);

    /* ── Düzeltme: container'ın ÖNÜNE ekle (sibling), içine değil ── */
    container.parentNode.insertBefore(triggerWrap, container);
  }

  function addTriggerButton() { injectBtn(); }

  function onAfterAjax() {
    sourceForm = getSourceForm();
    filterData = loadData();
    if (drawer) {
      var body = drawer.querySelector('.mf-body');
      if (body) body.innerHTML = buildGroupsHtml();
    }
    injectBtn();
    updateBadge();
    updateClearBtn();
    if (drawer && drawer.classList.contains('is-open')) fullSync();
  }

  ['facets:updated','facet:render:complete','collection:updated'].forEach(function(ev) {
    document.addEventListener(ev, onAfterAjax);
  });

  /*
   * MutationObserver — parent node'u izle.
   * Buton container dışında olduğu için AJAX tarafından silinmez;
   * ama sayfa route değişikliklerinde silinebilir, buna karşı önlem.
   */
  var btnObserver = new MutationObserver(function() {
    if (reinjectBusy) return;
    if (!document.querySelector('.mf-trigger-wrap')) {
      reinjectBusy = true;
      requestAnimationFrame(function() {
        injectBtn();
        updateBadge();
        reinjectBusy = false;
      });
    }
  });

  function startBtnObserver() {
    var container = document.querySelector('#ProductGridContainer');
    if (container && container.parentNode) {
      /* Parent'ı izle — direkt child değişimlerini yakala */
      btnObserver.observe(container.parentNode, { childList: true, subtree: false });
    }
  }

  function init() {
    buildDrawer();
    addTriggerButton();
    bindEvents();
    updateBadge();
    updateClearBtn();
    startBtnObserver();
  }

  if (document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();